export default __webpack_public_path__ + "static/media/FUJITSU STYLISTIC Q665.e59b7a43.png";